import React, { useEffect, useState } from "react";
import api from "../../api"
const ChatView = () => {
  const [chats, setChats] = useState([]);
  const [selectedChat, setSelectedChat] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false); // Sidebar toggle state
  const [showButton, setShowButton] = useState(true); // State to control button visibility

  useEffect(() => {
    document.body.classList.add("chatbody-class");
    const fetchData = async () => {
      try {
        const response = await api.get(
          `${process.env.REACT_APP_API_URL}/admin/bot/getbotlogs`
        );
        setChats(response.data.chats || []);
      } catch (err) {
        setError(
          err.response?.data?.message || err.message || "An error occurred"
        );
      } finally {
        setLoading(false);
      }
    };

    fetchData();
    return () => {
      document.body.classList.remove("chatbody-class");
    };
  }, []);

  const handleChatSelect = chat => {
    setSelectedChat(chat);
    setIsSidebarOpen(false); // Close sidebar on selecting a chat
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(prev => !prev);
    setShowButton(false); // Hide button when clicked
  };

  const formatDateTime = dateTimeString => {
    if (!dateTimeString) return "";
    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    };
    return new Intl.DateTimeFormat("en-US", options).format(
      new Date(dateTimeString)
    );
  };
  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <>
      {showButton && (
        <button
          className={`sidebar-toggle-btn sheeee ${
            isSidebarOpen ? "open" : "closed"
          }`}
          onClick={toggleSidebar}
        >
          {isSidebarOpen ? "Close Sidebar" : "Open Sidebar"}
        </button>
      )}
      <div className="chatview-container">
        <div
          className={`chatview-sidebar ${isSidebarOpen ? "open" : "closed"}`} // Sidebar classes based on toggle state
        >
          {/* <h2 style={styles.sidebarTitle}>Chats</h2> */}
          {chats.length === 0 ? (
            <div style={styles.noChats}>No chats available</div>
          ) : (
            <ul>
              {chats.map((chat, index) => (
                <li
                  key={index}
                  style={{
                    // ...styles.chatItem,
                    backgroundColor:
                      selectedChat === chat ? "rgb(247 247 247)" : "#fff",
                  }}
                  onClick={() => handleChatSelect(chat)}
                >
                  <span style={styles.chatIp}>{chat.ip_address}</span>
                </li>
              ))}
            </ul>
          )}
        </div>
        <div className="chatview-containers">
          {selectedChat ? (
            <>
              <div className="topnavs">
                <button className="sidebar-toggle-btn" onClick={toggleSidebar}>
                  Open Chat
                </button>
                <h2>
                  <span>Chat with {selectedChat.ip_address} </span>
                  <p className="chattime">
                    {formatDateTime(selectedChat.created_at)}
                  </p>
                </h2>
              </div>
              <div className="chat-portal">
                {selectedChat.chat.map((message, index) => (
                  <>
                    <div key={index}>
                      <div key={index} className="chat-message">
                        <div className="chat-message2">
                          <div className="chat-time">
                            {formatDateTime(message.sent_time)}
                          </div>
                          <p>{message.request}</p>
                        </div>
                      </div>

                      <div className="chat-message">
                        <div className="chat-message2">
                          <div className="chat-time">
                            {formatDateTime(message.received_time)}
                          </div>
                          <p>{message.response}</p>
                        </div>
                      </div>
                    </div>
                  </>
                ))}
              </div>
            </>
          ) : (
            <div style={styles.placeholder}>
              Select a chat to view the conversation
            </div>
          )}
        </div>
      </div>
    </>
  );
};

const styles = {
  chatTime: {
    fontSize: "0.9em",
    color: "#666",
  },
  container: {
    display: "flex",
    height: "100vh",
    fontFamily: "Arial, sans-serif",
  },
  sidebar: {
    width: "25%",
    borderRight: "1px solid #ddd",
    overflowY: "auto",
    backgroundColor: "#f9f9f9",
    padding: "10px",
  },
  sidebarTitle: {
    fontSize: "18px",
    textAlign: "center",
    marginBottom: "10px",
  },
  chatList: {
    listStyle: "none",
    padding: 0,
  },
  chatItem: {
    padding: "10px",
    cursor: "pointer",
    borderBottom: "1px solid #ddd",
  },
  chatIp: {
    fontWeight: "bold",
  },
  chatContainer: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    padding: "20px",
    overflowY: "auto",
  },
  chatTitle: {
    fontSize: "20px",
    marginBottom: "10px",
  },
  chatMessages: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    flexGrow: 1,
    overflowY: "auto",
  },
  messageContainer: {
    display: "flex",
    width: "100%",
  },
  message: {
    maxWidth: "70%",
    padding: "10px",
    borderRadius: "15px",
    wordWrap: "break-word",
    display: "inline-block",
  },
  placeholder: {
    textAlign: "center",
    color: "#666",
    marginTop: "20px",
  },
  noChats: {
    textAlign: "center",
    color: "#666",
    fontStyle: "italic",
  },
};

export default ChatView;
